/*
  Kiwi Ears · scroll reveal (Rene 2026-08-22).

  One generic reveal for the whole theme, so sections stop each shipping their
  own copy of the same twelve lines. A container marked [data-reveal] staggers
  its [data-reveal-item] children in as it enters the viewport, once.

  ScrollTrigger rather than IntersectionObserver, per CLAUDE.md — it stays in
  step with Lenis. Reduced motion gets the finished state immediately and no
  trigger is created at all; no GSAP gets the same. Loaded by more than one
  section, so it guards against running twice.

  Deliberately modest: y and opacity only, 0.55s, 60ms apart. This runs on
  utility pages in front of someone with a task, not a showreel.
*/
(function () {
  if (window.__kiwiRevealReady) return;
  window.__kiwiRevealReady = true;

  var groups = [].slice.call(document.querySelectorAll('[data-reveal]'));
  if (!groups.length) return;

  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function show(group) {
    [].slice.call(group.querySelectorAll('[data-reveal-item]')).forEach(function (el) {
      el.style.opacity = '';
      el.style.transform = '';
    });
  }

  function arm() {
    var g = window.gsap;
    if (!g || !window.ScrollTrigger || still) { groups.forEach(show); return; }

    var mm = g.matchMedia();
    mm.add('(prefers-reduced-motion: no-preference)', function () {
      groups.forEach(function (group) {
        var items = group.querySelectorAll('[data-reveal-item]');
        if (!items.length) return;
        g.set(items, { opacity: 0, y: 18 });
        window.ScrollTrigger.create({
          trigger: group,
          start: 'top 82%',
          once: true,
          onEnter: function () {
            g.to(items, {
              opacity: 1, y: 0, duration: 0.55, ease: 'power2.out',
              stagger: 0.06, clearProps: 'transform,opacity'
            });
          }
        });
      });
      /* [data-parallax] — a shared hook so a full-bleed band does not need its
         own inline script. The element is pre-scaled here rather than in CSS so
         the travel can never expose an edge, and the amount is per-element
         because a tall band needs more drift than a short one. */
      [].slice.call(document.querySelectorAll('[data-parallax]')).forEach(function (el) {
        var amt = parseFloat(el.getAttribute('data-parallax-amount')) || 5;
        g.set(el, { scale: 1 + (amt * 2 / 100) });
        g.fromTo(el, { yPercent: amt }, {
          yPercent: -amt, ease: 'none',
          scrollTrigger: {
            trigger: el.closest('section') || el,
            start: 'top bottom', end: 'bottom top', scrub: 1.1
          }
        });
      });

      /* a group already above the fold when the triggers are built never fires
         onEnter — the same initial-sync trap as the nav theme and the help rail */
      window.ScrollTrigger.refresh();

      /* Safety net. These items are CONTENT, not decoration: if a trigger never
         fires for any reason, the visitor loses the three steps entirely. Three
         seconds after load, anything still at zero opacity is simply shown. An
         animation that fails should cost the flourish, never the words. */
      setTimeout(function () {
        groups.forEach(function (group) {
          [].slice.call(group.querySelectorAll('[data-reveal-item]')).forEach(function (el) {
            if (parseFloat(getComputedStyle(el).opacity) < 0.05) {
              el.style.opacity = '';
              el.style.transform = '';
            }
          });
        });
      }, 3000);

      return function () { groups.forEach(show); };
    });
  }

  if (document.readyState === 'complete') arm();
  else window.addEventListener('load', arm);
})();
